import { TableColumnType } from 'src/types/table';

export const allColumns: TableColumnType[] = [
    { key: 'SSRC_CODE', label: 'ssrcCode', defaultShow: true },
    { key: 'NAME', label: 'name', defaultShow: true },
    { key: 'GEIS_PACKING_TYPE_CODE', label: 'geisCode', defaultShow: true },
    { key: 'TYPE', label: 'type', defaultShow: true },
    { key: 'BILLING_GROUP', label: 'billingGroup', defaultShow: false },
    { key: 'ACTIVE', label: 'active', type: 'select', selectOption: 'boolNumberCodes', defaultShow: true },
    { key: 'SORT_ORDER', label: 'sortOrder', type: 'number', defaultShow: true },
    { key: 'SYNCED_AT', label: 'syncedAt', type: 'dateTime', defaultShow: true },
];
